$(document).ready(function () {

  $('.mobile_slider').flickity({
    imagesLoaded: true,
    contain: true,
    percentPosition: true,
    wrapAround: true
  });

  setTimeout(function () {
    $(".shopify-payment-button__button").text('BUY NOW');
  }, 3000);

});

document.addEventListener('DOMContentLoaded', () => {
  $('.slider-for').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true
  });
  
  $('.seemore').click(function () {
    $('.ProductMeta__Description .Rte').addClass("more");
    $(this).addClass("hide");
    $('.seeless').removeClass("hide");
  });


  $('.seeless').click(function () {
    $('.ProductMeta__Description .Rte').removeClass("more");
    $(this).addClass("hide");
    $('.seemore').removeClass("hide");
  });

  const productForm = document.querySelector('.ProductForm');
  const inlineBuyButtons = productForm ? productForm.querySelector('.ProductForm__BuyButtons') : null;
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (productForm && inlineBuyButtons && isMobile) {
    // Create a sticky copy so the inline buttons stay visible when the bar sticks on mobile.
    const stickyBuyButtons = inlineBuyButtons.cloneNode(true);

    stickyBuyButtons.classList.add('ProductForm__BuyButtons--sticky');
    stickyBuyButtons.classList.remove('sticky');
    stickyBuyButtons.style.display = 'none';

    const inlineAddToCart = inlineBuyButtons.querySelector('.ProductForm__AddToCart');
    const stickyAddToCart = stickyBuyButtons.querySelector('.ProductForm__AddToCart');

    if (inlineAddToCart && stickyAddToCart) {
      stickyAddToCart.addEventListener('click', (event) => {
        event.preventDefault();
        inlineAddToCart.click();
      });
    }

    const inlineBuyNow = inlineBuyButtons.querySelector('#flo-buy-now-btn');
    const stickyBuyNow = stickyBuyButtons.querySelector('#flo-buy-now-btn') || stickyBuyButtons.querySelector('button[name="flo-buy-now-btn"]');

    if (stickyBuyNow) {
      stickyBuyNow.removeAttribute('id');

      if (inlineBuyNow) {
        stickyBuyNow.addEventListener('click', (event) => {
          event.preventDefault();
          inlineBuyNow.click();
        });
      }
    }

    inlineBuyButtons.after(stickyBuyButtons);

    const toggleStickyButtons = () => {
      if (window.scrollY > 700) {
        stickyBuyButtons.classList.add('sticky');
        stickyBuyButtons.style.display = 'flex';
      } else {
        stickyBuyButtons.classList.remove('sticky');
        stickyBuyButtons.style.display = 'none';
      }
    };

    toggleStickyButtons();
    document.addEventListener('scroll', toggleStickyButtons);
  }

});
